/* SAM custom: gate Add to Cart on required safe model/serial fields */
(function () {
  'use strict';

  function clearFieldError(input) {
    if (!input) return;
    input.classList.remove('is-invalid');
    var field = input.closest('.sam-safe-info__field');
    var error = field && field.querySelector('.sam-safe-info__error');
    if (error) error.classList.remove('is-visible');
  }

  function showFieldError(input) {
    if (!input) return;
    input.classList.add('is-invalid');
    var field = input.closest('.sam-safe-info__field');
    var error = field && field.querySelector('.sam-safe-info__error');
    if (error) error.classList.add('is-visible');
  }

  function validateSafeInfo(container) {
    var modelInput = container.querySelector('[data-safe-model-input]');
    var serialInput = container.querySelector('[data-safe-serial-input]');
    var modelValid = !!modelInput && modelInput.value.trim() !== '';
    var serialValid = !!serialInput && serialInput.value.trim() !== '';

    if (modelValid) {
      clearFieldError(modelInput);
    } else {
      showFieldError(modelInput);
    }

    if (serialValid) {
      clearFieldError(serialInput);
    } else {
      showFieldError(serialInput);
    }

    if (!modelValid && modelInput) {
      modelInput.focus();
    } else if (!serialValid && serialInput) {
      serialInput.focus();
    }

    return modelValid && serialValid;
  }

  /* Capture phase on document: runs before the theme's own delegated
     click handlers (variant-availability disable logic, ajax-cart submit),
     so we can block the click regardless of cart_action (redirect_cart,
     drawer, or mini_cart). */
  document.addEventListener(
    'click',
    function (event) {
      var trigger = event.target.closest('[data-add-to-cart-trigger]');
      if (!trigger) return;

      var productForm = trigger.closest('[data-product-form]');
      if (!productForm) return;

      var safeInfo = productForm.querySelector('[data-safe-info-fields]');
      if (!safeInfo) return;

      if (!validateSafeInfo(safeInfo)) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        var warning = productForm.querySelector('.cart-warning');
        if (warning) {
          warning.textContent = "Please enter your safe's model and serial number before adding to cart.";
        }
      }
    },
    true
  );

  document.addEventListener('input', function (event) {
    var input = event.target;
    if (!input.matches('[data-safe-model-input], [data-safe-serial-input]')) return;
    if (input.value.trim() !== '') {
      clearFieldError(input);
    }
  });
})();
